import type { FaireProductEntity } from "../../entity_types/product";

export const p_dvqbrgpb2m: FaireProductEntity = {
  token: "p_dvqbrgpb2m",
  type: "product",
  name: "Butts Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/5e22e220548f975f9c597b44a8a8516a30650e812b3bc44a1d483ac7e4d61107.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/562e99d27b2b8f433826e8dee1c7330246bfd665f6015b383e1a2c0ab5a45c81.jpeg",
    "https://cdn.faire.com/fastly/f71c680881b1bab999a273c6dde4822c9a1a3979131c4c060ae5ff34d09b5b00.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/b4b242444457ee3fb987add502e26922ab662977493c0d28523ed42d7c06bcc4.jpeg",
    "https://cdn.faire.com/fastly/b32e34d47306eebdd651b247713c837939b0c92bf3465f24b4efd2f7e4a6ecad.jpeg",
    "https://cdn.faire.com/fastly/c494c33d4fbd31cea9ffabd1fc0fdac8b65d573de8a4da347c0bd6b0311cb7be.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nHigh fashion? No. Low cheeks? Absolutely. These socks are for people who know that maturity is overrated and butts are forever funny. 🍑\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:27.742Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
